import { appApi } from '../app_api';

export const instancesApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getInstances: builder.query({
      query: ({ groupId }) => `/groups/${groupId}/player_instances`,
      transformResponse: (response) => Array.isArray(response.data) ? response.data : [],
      providesTags: (result, error, { groupId }) =>
        result
          ? [
              ...result.map(({ id }) => ({ type: 'Instance', id })),
              { type: 'GroupInstances', id: groupId },
            ]
          : [{ type: 'GroupInstances', id: groupId }],
    }),
    addLatePlayer: builder.mutation({
      query: ({ groupId, player }) => ({
        url: `/groups/${groupId}/add_late_player`,
        method: 'POST',
        body: { player, manager_consent_attested: true },
      }),
      // Regenerating the group's matches touches its instances, matches,
      // leaderboard and the round-level completion gates — refresh them all.
      invalidatesTags: (result, error, { groupId, roundId, eventId }) => [
        { type: 'GroupInstances', id: groupId },
        { type: 'GroupMatches', id: groupId },
        { type: 'GroupLeaderboard', id: groupId },
        { type: 'GroupConflicts', id: groupId },
        { type: 'Group', id: groupId },
        { type: 'EventRoundGroups', id: roundId },
        { type: 'EventFinishedAllMatchesRound', id: roundId },
        { type: 'EventGroupsReviewedRound', id: roundId },
        { type: 'RoundCanContinue', id: roundId },
        { type: 'RoundQualifiedPlayersCount', id: roundId },
        { type: 'EventPlayers', id: eventId },
      ],
    }),
  }),
});

export const { useGetInstancesQuery, useAddLatePlayerMutation } = instancesApi;